import styled, { css } from 'styled-components';
import { device } from '../breakpoints';

export const ContainerBase = css`
    clear: both;
    display: block;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    margin-left: 10px;
    margin-right: 10px;

    @media ${device.GteSmall} {
        margin-left: 15px;
        margin-right: 15px;
    }

    @media ${device.GteXLarge} {
        margin-left: 75px;
        margin-right: 75px;
    }

    @media ${device.FullScreen} {
        margin-left: 100px;
        margin-right: 100px;
    }
`;

export const PlayContainerBase = styled.div`
    ${ContainerBase}
`;

export const PlayContainer = styled.div`
    margin-left: ${(props) => props.xs || '10px'};
    margin-right: ${(props) => props.xs || '10px'};
    margin-top: ${(props) => props.marginTop || 0};

    @media ${device.GteSmall} {
        margin-left: ${(props) => props.s || '15px'};
        margin-right: ${(props) => props.s || '15px'};
    }

    @media ${device.GteLarge} {
        margin-left: ${(props) => props.l || '0'};
        margin-right: ${(props) => props.l || '0'};
    }
`;
